var render = function (_h,_vm) {var _c=_vm._c;return _c('v-text-field',_vm._g({staticClass:"c-base-text-field",attrs:{"dense":"","disabled":_vm.props.disabled,"hide-details":"","spellcheck":false,"placeholder":_vm.props.placeholder,"color":"info","value":_vm.props.value,"maxlength":_vm.props.maxlength}},_vm.listeners))}
var staticRenderFns = []

export { render, staticRenderFns }